<template>
  <div class="body-360-stats">
    <section class="main">
      <!-- <a id="buttonTime" class="time itemH" @click="dialog.queryParams.show = true">
          <span class="fM primary">今日</span>
          <div class="icon"><font-awesome-icon size="2x" icon="caret-down" /></div>
      </a> -->

      <!-- HEADER ROW - TOTAL AMOUNT & QUERY SETTINGS -->
      <el-row>
        <el-col :span="24" :md="12">
          <span class="fXL margin gray">總營業額</span><br>
          <span class="fXXL margin bold">${{ totalAmount }}</span>
          <div class="itemH" v-show="false">
              <div class="icon success"><font-awesome-icon size="2x" icon="arrow-up" /></div>
              <span class="fL bold success">$10,000</span>
          </div>
        </el-col>

        <el-col :span="24" :md="12">

          <el-row>
            <el-col :span="24">
              <div class="d-flex align-items-center">
                <ShopPicker :width="200" @select="onShopSelected"></ShopPicker>
                <el-button circle type="default" class="ml-2 my-3" icon="el-icon-refresh"
                  :disabled="!shopId" @click="forceReload">
                </el-button>
              </div>
            </el-col>            

            <el-col :span="24">
              <el-form label-position="left" label-width="72px" style="max-width: 360px;">
                <el-form-item label="開始時間" class="mb-0">
                  <fg-input>
                    <el-date-picker type="datetime" v-model="dates[0]" placeholder="From" width="240px"
                      popper-class="time-panel-adjust"
                      @change="onQueryDateRangeChanged">
                    </el-date-picker>
                  </fg-input>
                </el-form-item>
                <el-form-item label="結束時間" class="mb-0">
                  <fg-input>
                    <el-date-picker type="datetime" v-model="dates[1]" placeholder="To"
                      popper-class="time-panel-adjust"
                      @change="onQueryDateRangeChanged">
                    </el-date-picker>
                  </fg-input>
                </el-form-item>
              </el-form>
            </el-col>

            <el-col :span="24">
              <el-button round size="mini" @click="onDateRangeShortcutClicked('today')">今日</el-button>
              <el-button round size="mini" @click="onDateRangeShortcutClicked('this-week')">本週</el-button>
              <!-- <el-button round size="mini" @click="onDateRangeShortcutClicked('2-days-ago')">前日</el-button> -->
              <el-button round size="mini" @click="onDateRangeShortcutClicked('this-month')">本月</el-button>
            </el-col>
            <el-col :span="24" class="mt-2">
              <el-button round size="mini" @click="onDateRangeShortcutClicked('yesterday')">昨日</el-button>
              <el-button round size="mini" @click="onDateRangeShortcutClicked('last-week')">上週</el-button>
              <el-button round size="mini" @click="onDateRangeShortcutClicked('last-month')">上月</el-button>
            </el-col>

            <!-- <el-col :span="24">
              <fg-input>
                <el-date-picker type="datetimerange" v-model="dates"
                  range-separator="到" start-placeholder="Start date" end-placeholder="End date"
                  format="yyyy-MM-dd" size="mini" :picker-options="pickerOptions"
                  @change="onQueryDateRangeChanged">
                </el-date-picker>
              </fg-input>
            </el-col> -->

          </el-row>
          
        </el-col>

      </el-row>

      <!-- 總營業額 -->
      <!-- <span class="fXL margin gray">總營業額</span>
      <span class="fXXL margin bold">${{ totalAmount }}</span>
      <div class="itemH">
          <div class="icon success"><font-awesome-icon size="2x" icon="arrow-up" /></div>
          <span class="fL bold success">$10,000</span>
      </div> -->
      <!-- <div class="spaceL"></div> -->

      <!-- 收入來源分佈 -->
      <div class="itemV width">
        <span class="fL margin">收入來源分佈</span>
        <div class="itemH width">
            <div class="income itemV background between">
                <div class="itemH width between start">
                    <div class="icon"><font-awesome-icon size="2x" icon="cash-register" /></div>
                    <a class="icon minor" ontouchstart="handleStart(event)">
                        <font-awesome-icon size="2x" icon="info-circle" />
                        <div class="info itemV padding"><span class="fM">包含現金、POS、愛點餐飲等現場收款方式</span></div>
                    </a>
                </div>
                <span class="fL margin gray single">現場收入</span>
                <div class="itemV margin start">
                    <span class="fXL bold">${{ totalAmount - totalCreditCardIncome - total3rdPartyOnlinePaymentIncome - total3rdPartyPlatformIncome }}</span>
                    <div class="itemH" v-show="false">
                        <div class="icon success fit"><font-awesome-icon size="2x" icon="arrow-up" /></div>
                        <span class="fM bold success">20%</span>
                    </div>
                </div>
            </div>
            <div class="income itemV background between">
                <div class="itemH width between start">
                    <div class="icon"><font-awesome-icon size="2x" icon="credit-card" /></div>
                    <a class="icon minor" ontouchstart="handleStart(event)">
                        <font-awesome-icon size="2x" icon="info-circle" />
                        <div class="info itemV padding"><span class="fM">包含信用卡、Apple Pay 、Google Pay等支付服務</span></div>
                    </a>
                </div>
                <span class="fL margin gray single">信用卡收入</span>
                <div class="itemV margin start">
                    <span class="fXL bold">${{ totalCreditCardIncome }}</span>
                    <div class="itemH" v-show="false">
                        <div class="icon error fit"><font-awesome-icon size="2x" icon="arrow-down" /></div>
                        <span class="fM bold error">5%</span>
                    </div>
                </div>
            </div>
            <div class="income itemV background between">
                <div class="itemH width between start">
                    <div class="icon"><font-awesome-icon size="2x" icon="window-restore" /></div>
                    <a class="icon minor" ontouchstart="handleStart(event)">
                        <font-awesome-icon size="2x" icon="info-circle" />
                        <div class="info itemV padding"><span class="fM">包含UberEats、foodpanda</span></div>
                    </a>
                </div>
                <span class="fL margin gray single">第三方平台收入</span>
                <div class="itemV margin start">
                    <span class="fXL bold">${{ total3rdPartyPlatformIncome }}</span>
                    <div class="itemH" v-show="false">
                        <div class="icon success fit"><font-awesome-icon size="2x" icon="arrow-up" /></div>
                        <span class="fM bold success">20%</span>
                    </div>
                </div>
            </div>
            <div class="income itemH background">
                <div class="itemV width height between">
                    <div class="itemH width between start">
                        <div class="icon"><font-awesome-icon size="2x" icon="mobile-alt" /></div>
                        <a class="icon minor" ontouchstart="touchInfo(event)">
                            <font-awesome-icon size="2x" icon="info-circle" />
                            <div class="info itemV padding"><span class="fM">包含LINE Pay、街口支付、悠遊付、台灣Pay、全支付、全盈+PAY、icash Pay</span></div>
                        </a>
                    </div>
                    <span class="fL margin gray single">第三方支付</span>
                    <div class="itemV margin start">
                        <span class="fXL bold">${{ total3rdPartyOnlinePaymentIncome }}</span>
                        <div class="itemH" v-show="false">
                            <div class="icon error fit"><font-awesome-icon size="2x" icon="arrow-down" /></div>
                            <span class="fM bold error">5%</span>
                        </div>
                    </div>
                </div>
                <div class="itemV width height between">
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/linepay.png"></div>
                            <span class="detail fM single">LINE Pay</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.linepay }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/jkopay.png"></div>
                            <span class="detail fM single">街口支付</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.jkopay }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/easywallet.png"></div>
                            <span class="detail fM single">悠遊付</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.easywallet }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/taiwanpay.png"></div>
                            <span class="detail fM single">台灣Pay</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.taiwanpay }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/pxpay.png"></div>
                            <span class="detail fM single">全支付</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.pxpayplus }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/pluspay.png"></div>
                            <span class="detail fM single">全盈+PAY</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.pluspay }}</span>
                    </div>
                    <div class="itemH width between">
                        <div class="itemH">
                            <div class="img"><img src="@/assets/img/360-stats/icash.png"></div>
                            <span class="detail fM single">icash Pay</span>
                        </div>
                        <span class="detail fM">${{ stats.amount.qpay.icashpay }}</span>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="spaceL"></div>
      <!-- 訂單平台分佈 -->
      <div class="itemV width">
          <span class="fL margin">訂單平台分佈</span>
          <div class="platform itemH width padding background">
              <table class="fM">
                  <tr>
                      <th><span class="gray">訂單平台</span></th>
                      <th><span class="gray">訂單數</span></th>
                      <th><span class="gray">營業額</span></th>
                      <th><span></span></th>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><img src="@/assets/img/360-stats/ubereats.png"></div>
                              <span>UberEats</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.ubereats }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.ubereats }}</span>
                      </td>
                      <td>
                          <div class="dot tc1"></div>
                      </td>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><img src="@/assets/img/360-stats/foodpanda.png"></div>
                              <span>foodpanda</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.foodpanda }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.foodpanda }}</span>
                      </td>
                      <td>
                          <div class="dot tc3"></div>
                      </td>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><img src="@/assets/img/360-stats/quickclick.png"></div>
                              <span>線上點餐</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.quickclick + stats.count.platform.gofoodie }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.quickclick + stats.amount.platform.gofoodie }}</span>
                      </td>
                      <td>
                          <div class="dot tc4"></div>
                      </td>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><img src="@/assets/img/360-stats/counter.png"></div>
                              <span>愛點餐飲</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.counter }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.counter }}</span>
                      </td>
                      <td>
                          <div class="dot tc7"></div>
                      </td>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><img src="@/assets/img/360-stats/sok.png"></div>
                              <span>自助點餐平板</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.sok || 0 }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.sok || 0 }}</span>
                      </td>
                      <td>
                          <div class="dot tc5"></div>
                      </td>
                  </tr>
                  <tr>
                      <td align="center">
                          <div class="itemH">
                              <div class="img"><span class="fS">其它</span></div>
                              <span>其它平台</span>
                          </div>
                      </td>
                      <td align="center">
                          <span>{{ stats.count.platform.others }}</span>
                      </td>
                      <td align="center">
                          <span class="bold">${{ stats.amount.platform.others }}</span>
                      </td>
                      <td>
                          <div class="dot tc8"></div>
                      </td>
                  </tr>
              </table>
              <div class="pieChart itemV width">
                <doughnut-chart :chart-data="chart.platforms" :height="330"></doughnut-chart>
                  <!-- <canvas id="pieChart"></canvas> -->
                  <div class="itemV center middle">
                      <span class="fL">總營業額</span>
                      <span class="fL bold">${{ totalAmount }}</span>
                  </div>
              </div>
          </div>
      </div>
    </section>

  </div>
</template>

<script>
import DoughnutChart from 'src/components/Charts/DoughnutChart';
import Chart from 'chart.js';
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';
//WARNING: We give datalabels anchoring settings by default, try not to change them~
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.plugins.datalabels.anchor = 'center';//So that number label is attached to the "top" of each bar.
Chart.defaults.global.plugins.datalabels.font = { weight: 'bold', size: 16 };
Chart.defaults.global.plugins.datalabels.color = 'white';
Chart.defaults.global.plugins.datalabels.formatter = function (val, ctx) {
  return val > 0? `$${val}`: '';//Only show datalabels for non-zero values.
};
// import ShopFinder from 'src/components/ShopFinder.vue';
import ShopPicker from 'src/components/ShopPicker.vue';

import moment from 'moment';
import axios from 'axios';

export default {
  components: {
    DoughnutChart,
    ChartJSPluginDatalabels,
    // ShopFinder,
    ShopPicker
  },

  mounted() {
    // this.fetchBasicStats();
  },

  methods: {
    onQueryDateRangeChanged(args) {
      console.log(`[360Stats] onQueryDateRangeChanged`, this.dates);
    },
    onDateRangeShortcutClicked(code) {
      switch (code) {
        case 'today': {
          this.dates = [
            moment().startOf('day').toDate(),
            moment().endOf('day').toDate(),
          ];
          break;
        }
        case 'yesterday': {
          this.dates = [
            moment().add(-1, 'days').startOf('day').toDate(),
            moment().add(-1, 'days').endOf('day').toDate(),
          ];
          break;
        }
        case '2-days-ago': {
          this.dates = [
            moment().add(-2, 'days').startOf('day').toDate(),
            moment().add(-2, 'days').endOf('day').toDate(),
          ];
          break;
        }
        case 'this-week': {
          this.dates = [
            moment().startOf('isoWeek').toDate(),
            moment().endOf('isoWeek').toDate(),
          ];
          break;
        }
        case 'last-week': {
          this.dates = [
            moment().add(-1, 'weeks').startOf('isoWeek').toDate(),
            moment().add(-1, 'weeks').endOf('isoWeek').toDate(),
          ];
          break;
        }
        case 'this-month': {
          this.dates = [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
          ];
          break;
        }
        case 'last-month': {
          this.dates = [
            moment().add(-1, 'months').startOf('month').toDate(),
            moment().add(-1, 'months').endOf('month').toDate(),
          ];
          break;
        }
      }
      this.fetchBasicStats();
    },
    onShopSelected(shopId, shopData) {
      console.log(`[360Stats] onShopSelected`, shopId, shopData);
      this.shopId = shopId;
      this.shopMerchantId = shopData['merchantId'];
      this.fetchBasicStats();
    },
    forceReload() {
      console.log(`FORCE RELOAD`);
      this.fetchBasicStats();
    },

    fetchBasicStats() {
      // Check query parameters
      if (!this.shopId) {
        console.warn(`[360Stats] You must select a shop first.`);
        this.$swal({
          title: '必須先選定店家', buttonStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
        return;
      }
      let m1 = moment(this.dates[0]), m2 = moment(this.dates[1]);
      if (m1.isAfter(m2)) {
        this.$swal({
          title: '開始日期不得晚於結束日期', buttonStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
        return;
      }

      axios.get(this.loadStatsUrl)
      .then(response => {
        console.log(`[360Stats] Basic stats obtained`, response.data);
        this.stats.amount = response.data['amount'];
        this.stats.count = response.data['count'];
        this.drawPlatfromRatioChart(this.stats.amount.platform);
      })
      .catch(err => {
        console.error(`[360Stats] Failed to fetch basic stats`, err);
      });
    },

    drawPlatfromRatioChart(stats) {
      this.chart.platforms = {
        labels: [ 'UberEats', 'foodpanda', '線上點餐', '愛點餐飲', '自助點餐平板', '其它平台' ],
        datasets: [
          {
            data: [ stats.ubereats, stats.foodpanda, stats.quickclick + stats.gofoodie, stats.counter, stats.sok || 0, stats.others ],
            backgroundColor: [ '#13c66f', '#d41464', '#f6981d', '#FFCE54', '#48CFAD', '#AC92EC' ],
            borderColor: '#F2F1F6'
          }
        ]
      };
    }
  },

  data() {
    return {
      isLoading: true,

      dates: [
        moment().startOf('day').toDate(),
        moment().endOf('day').toDate()
      ],
      shopId: 0,
      shopMerchantId: null,

      stats: {
        amount: {
          platform: { ubereats: 0, foodpanda: 0, quickclick: 0, gofoodie: 0, counter: 0, sok: 0, others: 0 },
          qpay: { credit: 0, applepay: 0, googlepay: 0, linepay: 0, easywallet: 0, jkopay: 0, taiwanpay: 0, pxpayplus: 0, pluspay:0, icashpay: 0 }
        },
        count: {
          platform: { ubereats: 0, foodpanda: 0, quickclick: 0, gofoodie: 0, counter: 0, sok: 0, others: 0 },
          qpay: { credit: 0, applepay: 0, googlepay: 0, linepay: 0, easywallet: 0, jkopay: 0, taiwanpay: 0, pxpayplus: 0, pluspay:0, icashpay: 0 }
        }
      },

      chart: {
        platforms: {
          labels: [ ],
          datasets: [ { data: [ ] } ]
        }
      },

      dialog: {
        queryParams: {
          show: false,
          from: null,
          to: null
        }
      },

      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: '今日',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().startOf('day').toDate(), moment().endOf('day').toDate() ]);
      //       }
      //     },
      //     {
      //       text: '昨日',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().add(-1, 'days').startOf('day').toDate(), moment().add(-1, 'days').endOf('day').toDate() ]);
      //       }
      //     },
      //     {
      //       text: '本週',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().startOf('isoWeek').toDate(), moment().endOf('isoWeek').toDate() ]);
      //       }
      //     },
      //     {
      //       text: '上週',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().add(-1, 'weeks').startOf('isoWeek').toDate(), moment().add(-1, 'weeks').endOf('isoWeek').toDate() ]);
      //       }
      //     },
      //     {
      //       text: '本月',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().startOf('month').toDate(), moment().endOf('month').toDate() ]);
      //       }
      //     },
      //     {
      //       text: '上個月',
      //       onClick(picker) {
      //         picker.$emit('pick', [ moment().add(-1, 'months').startOf('month').toDate(), moment().add(-1, 'months').endOf('month').toDate() ]);
      //       }
      //     }
      //   ]
      // }
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    loadStatsUrl() {
      let fromTs = moment(this.dates[0]).unix();
      let toTs = moment(this.dates[1]).unix();
      return `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shopId}/360-basic?from=${fromTs}&to=${toTs}`
        + `&merchantId=${this.shopMerchantId}`;
    },

    totalAmount() {
      return this.stats.amount.total || 0;
    },
    totalCreditCardIncome() {
      if (!this.stats.amount.qpay) return 0;
      return this.stats.amount.qpay.credit
        + this.stats.amount.qpay.applepay
        + this.stats.amount.qpay.googlepay;
    },
    total3rdPartyOnlinePaymentIncome() {
      if (!this.stats.amount.qpay) return 0;
      return this.stats.amount.qpay.linepay
        + this.stats.amount.qpay.easywallet
        + this.stats.amount.qpay.taiwanpay
        + this.stats.amount.qpay.jkopay
        + this.stats.amount.qpay.pxpayplus
        + this.stats.amount.qpay.pluspay
        + this.stats.amount.qpay.icashpay;
    },
    total3rdPartyPlatformIncome() {
      if (!this.stats.amount.platform) return 0;
      return this.stats.amount.platform.ubereats
        + this.stats.amount.platform.foodpanda
        + this.stats.amount.platform.others;
    }
  }

};
</script>

<style scoped src="../../../assets/css/360-stats.css">
</style>

<style>
.time-panel-adjust .el-time-panel {
  left: -32px;
}
</style>
